import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar/Navbar';
import QuickLinks from './components/QuickLinks/QuickLinks';
import Home from './components/Home/Home';
import About from './components/About/About';
import Rabi from './components/Products/Rabi';
import Kharif from './components/Products/Kharif';
import FieldCrops from './components/Products/FieldCrops';
import Header from './components/Header/Header';
import 'bootstrap/dist/css/bootstrap.min.css'; 
import 'bootstrap/dist/js/bootstrap.bundle.min.js'; 
import Footer from './components/Footer/Footer';
import Wheat from './components/Products/Wheat';
import Gram from './components/Products/Gram';
import Lentil from './components/Products/Lentil';
import Barley from './components/Products/Barley';
import Toria from './components/Products/Toria';
import Mustard from './components/Products/Mustard';
import Cotton from './components/Products/Cotton';
import Guar from './components/Products/Guar';
import Bajra from './components/Products/Bajra';
import Paddy from './components/Products/Paddy';
import Arhar from './components/Products/Arhar';
import Til from './components/Products/Til';
import Moth from './components/Products/Moth';
import Moong from './components/Products/Moong';
import Urad from './components/Products/Urad';
import Maize from './components/Products/Maize';
import Vegetables from './components/Products/Vegetables';
import Schemes from './components/Products/Schemes';
import RabiVeg from './components/Products/RabiVeg';
import KharifVeg from './components/Products/KharifVeg';
import ProductionStages from './components/Production/ProductionStages';
import SeedProduction from './components/Production/SeedProduction';
import SeedProcessing from './components/Production/SeedProcessing';
import Incentives from './components/Production/Incentives';
import Engineering from './components/Engineering/Engineering';
import Finance from './components/Finance/Finance';
import Tenders from './components/Tenders/Tenders';
import Archived from './components/Tenders/Archived';
import ContactUs from './components/Contact/ContactUs';
import ServiceRules from './components/Administration/ServiceRules';
import Circulars from './components/Administration/Circulars';
import Forms from './components/Administration/Forms';
import Manuals from './components/Administration/Manuals';
import Notifications from './components/Administration/Notifications';
import Placement from './components/Administration/Placement';
import Policies from './components/Administration/Policies';
import Transfers from './components/Administration/Transfers';
import Miscellaneous from './components/Administration/Miscellaneous';
import AntiStubbleBuringCampaign from './components/Administration/AntiStubbleBuringCampaign';
import Directors from './components/Directory/Directors';
import HeadOffices from './components/Directory/HeadOffices';
import RegionalOfficesD from './components/Directory/RegionalOffices';
import RegionalOfficesM from './components/Marketing/RegionalOffices';
import SaleRateRabiCropsSeeds from './components/Marketing/SaleRateRabiCropsSeeds';
import SaleRateRabiCropsVegetables from './components/Marketing/SaleRateRabiCropsVegetables';
import SaleRateKharifCropsSeeds from './components/Marketing/SaleRateKharifCropsSeeds';
import SaleRateKharifSeedsVegetables from './components/Marketing/SaleRateKharifSeedsVegetables';
import AvailabilityRabiSeeds from './components/Marketing/AvailabilityRabiSeeds';
import AvailabilityKharifSeeds from './components/Marketing/AvailabilityKharifSeeds';
import ListofSaleCounters from './components/Marketing/ListofSaleCounters';
import SaleRate from './components/Marketing/SaleRate';
import CitizenServices from './components/Marketing/CitizenServices';
import SubsidyProgram from './components/Marketing/SubsidyProgram';
import SeedsAllocation from './components/Marketing/SeedsAllocation';
import ComplaintCommittee from './components/QuickLinks/ComplaintCommittee';
import AuditCell from './components/QuickLinks/AuditCell';
import QualityControl from './components/QuickLinks/QualityControl';
import GrowerAgreements from './components/QuickLinks/GrowerAgreements';
import Services from './components/QuickLinks/Services';
import Rti from './components/QuickLinks/Rti';
import ApplicationForm from './components/QuickLinks/ApplicationForm';
import ListofAuthorities from './components/QuickLinks/ListofAuthorities';
import Fees from './components/QuickLinks/Fees';
import RTIReplies from './components/QuickLinks/RTIReplies';
import ProactiveDisclouser from './components/QuickLinks/ProactiveDisclouser';
import ParticularsOrganization from './components/QuickLinks/ParticularsOrganization';
import PowersDuties from './components/QuickLinks/PowersDuties';
import Procedure from './components/QuickLinks/Procedure';
import Norms from './components/QuickLinks/Norms';
import RulesRegulations from './components/QuickLinks/RulesRegulations';
import StatementCategories from './components/QuickLinks/StatementCategories';
import ParticularsArrangement from './components/QuickLinks/ParticularsArrangement';
import Statements from './components/QuickLinks/Statements';
import DirectoryOfficers from './components/QuickLinks/DirectoryOfficers';
import Remuneration from './components/QuickLinks/Remuneration';
import Budget from './components/QuickLinks/Budget';
import MannerExecution from './components/QuickLinks/MannerExecution';
import ParticularsRecipients from './components/QuickLinks/ParticularsRecipients';
import DetailsInformation from './components/QuickLinks/DetailsInformation';
import Facilities from './components/QuickLinks/Facilities';
import InformationOfficers from './components/QuickLinks/InformationOfficers';
import Faqs from './components/QuickLinks/Faqs';
import Gallery from './components/Footer/Gallery';
import Accessibility from './components/Footer/Accessibility';
import WebsitePolicies from './components/Footer/WebsitePolicies';
import Terms from './components/Footer/Terms';
import Disclaimer from './components/Footer/Disclaimer';
import Help from './components/Footer/Help';
import Feedback from './components/Footer/Feedback';
import Sitemap from './components/Footer/Sitemap';
import ScreenReader from './components/Header/ScreenReader';
import Home1 from './components/Dashboard/Home';
import Dashboard from './components/Dashboard/Dashboard';
import Images from './components/Dashboard/Images';
import Notifications1 from './components/Dashboard/Notifications';
import Links from './components/Dashboard/Links';
import Login from './components/Login/login';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import "bootstrap-icons/font/bootstrap-icons.css";
import Directory from './components/Dashboard/Directory';
import News from './components/Home/News';
import Loader from './components/Loader/Loader';
import { useSelector } from 'react-redux';
import Authorities from './components/Dashboard/Authorities';
const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return null; 
};

const AppContent = () => {

const isLoading = useSelector((state) => state.loading.value)
  return (
    <>
     {isLoading && <Loader />}
 <ScrollToTop />
      <div className="container-fluid" id="main-content">
        <div className="row">
          <div className="col-lg-8 col-md-8 col-sm-12">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about-us" element={<About />} />
              <Route path="/screen-access-reader" element={<ScreenReader />} />
              <Route path="/products/field-crops" element={<FieldCrops />} />
              <Route path="/products/field-crops/rabi-crops" element={<Rabi />} />
              <Route path="/products/field-crops/kharif-crops" element={<Kharif />} />
              <Route path="/products/field-crops/rabi-crops/wheat" element={<Wheat/>} />
              <Route path="/products/field-crops/rabi-crops/gram" element={<Gram/>} />
              <Route path="/products/field-crops/rabi-crops/lentil" element={<Lentil/>} />
              <Route path="/products/field-crops/rabi-crops/barley" element={<Barley/>} />
              <Route path="/products/field-crops/rabi-crops/toria" element={<Toria/>} />
              <Route path="/products/field-crops/rabi-crops/mustard" element={<Mustard/>} />
              <Route path="/products/field-crops/kharif-crops/cotton" element={<Cotton/>} />
              <Route path="/products/field-crops/kharif-crops/guar" element={<Guar/>} />
              <Route path="/products/field-crops/kharif-crops/bajra" element={<Bajra/>} />
              <Route path="/products/field-crops/kharif-crops/paddy" element={<Paddy/>} />
              <Route path="/products/field-crops/kharif-crops/arhar" element={<Arhar/>} />
              <Route path="/products/field-crops/kharif-crops/til" element={<Til/>} />
              <Route path="/products/field-crops/kharif-crops/moth" element={<Moth/>} />
              <Route path="/products/field-crops/kharif-crops/moong" element={<Moong/>} />
              <Route path="/products/field-crops/kharif-crops/urad" element={<Urad/>} />
              <Route path="/products/field-crops/kharif-crops/maize" element={<Maize/>} />
              <Route path="/products/vegetables" element={<Vegetables/>} />
              <Route path="/schemes" element={<Schemes/>} />
              <Route path="/products/vegetables/rabi-crops-Vegetables" element={<RabiVeg/>} />
              <Route path="/products/vegetables/kharif-crops-Vegetables" element={<KharifVeg/>} />
              <Route path="/production/stages" element={<ProductionStages/>} />
              <Route path="/production/seed-production" element={<SeedProduction/>} />
              <Route path="/production/seed-processing" element={<SeedProcessing/>} />
              <Route path="/production/incentives" element={<Incentives/>} />
              <Route path="/engineering" element={<Engineering/>} />
              <Route path="/finance" element={<Finance/>} />
              <Route path="/tenders" element={<Tenders/>} />
              <Route path="/tenders/archived" element={<Archived/>} />
              <Route path="/contact-us" element={<ContactUs/>} />
              <Route path="/administration/service-rules" element={<ServiceRules/>} />
              <Route path="/administration/circulars" element={<Circulars/>} />
              <Route path="/administration/forms" element={<Forms/>} />
              <Route path="/administration/manuals" element={<Manuals/>} />
              <Route path="/administration/notifications" element={<Notifications/>} />
              <Route path="/administration/placement" element={<Placement/>} />
              <Route path="/administration/policies" element={<Policies/>} />
              <Route path="/administration/transfers" element={<Transfers/>} />
              <Route path="/administration/miscellaneous" element={<Miscellaneous/>} />
              <Route path="/administration/anti-stubble-buring-campaign" element={<AntiStubbleBuringCampaign/>} />
              <Route path="/directory/directors" element={<Directors/>} />
              <Route path="/directory/head-offices" element={<HeadOffices/>} />
              <Route path="/directory/regional-offices" element={<RegionalOfficesD/>} />
              <Route path="/marketing/rabi-seeds" element={<SaleRateRabiCropsSeeds/>} />
              <Route path="/marketing/rabi-vegetables" element={<SaleRateRabiCropsVegetables/>} />
              <Route path="/marketing/kharif-seeds" element={<SaleRateKharifCropsSeeds/>} />
              <Route path="/marketing/kharif-vegetables" element={<SaleRateKharifSeedsVegetables/>} />
              <Route path="/marketing/rabi-availability" element={<AvailabilityRabiSeeds/>} />
              <Route path="/marketing/kharif-availability" element={<AvailabilityKharifSeeds/>} />
              <Route path="/marketing/offices" element={<RegionalOfficesM/>} />
              <Route path="/marketing/sale-counters" element={<ListofSaleCounters/>} />
              <Route path="/marketing/sale-rate-agro" element={<SaleRate/>} />
              <Route path="/marketing/citizen-services" element={<CitizenServices/>} />
              <Route path="/marketing/subsidy-program" element={<SubsidyProgram/>} />
              <Route path="/marketing/seeds-allocation" element={<SeedsAllocation/>} />
              <Route path="/internal-complaint-committee" element={<ComplaintCommittee/>} />
              <Route path="/audit-cell" element={<AuditCell/>} />
              <Route path="/quality-control" element={<QualityControl/>} />
              <Route path="/agreements" element={<GrowerAgreements/>} />
              <Route path="/services" element={<Services/>} />
              <Route path="/rti" element={<Rti/>} />
              <Route path="/rti/application-form" element={<ApplicationForm/>} />
              <Route path="/rti/list-of-authorities" element={<ListofAuthorities/>} />
              <Route path="/rti/fees" element={<Fees/>} />
              <Route path="/rti/rti-replies" element={<RTIReplies/>} />
              <Route path="/rti/proactive-disclouser" element={<ProactiveDisclouser/>} />
              <Route path="/rti/proactive-disclouser/particulars-of-organization" element={<ParticularsOrganization/>} />
              <Route path="/rti/proactive-disclouser/powers-duties" element={<PowersDuties/>} />
              <Route path="/rti/proactive-disclouser/procedure-followed" element={<Procedure/>} />
              <Route path="/rti/proactive-disclouser/norms" element={<Norms/>} />
              <Route path="/rti/proactive-disclouser/rules-regulations-instructions" element={<RulesRegulations/>} />
              <Route path="/rti/proactive-disclouser/statement-of-categories" element={<StatementCategories/>} />
              <Route path="/rti/proactive-disclouser/particulars-of-any-arrangement" element={<ParticularsArrangement/>} />
              <Route path="/rti/proactive-disclouser/statements" element={<Statements/>} />
              <Route path="/rti/proactive-disclouser/directory-of-officers-employees" element={<DirectoryOfficers/>} />
              <Route path="/rti/proactive-disclouser/monthly-remuneration" element={<Remuneration/>} />
              <Route path="/rti/proactive-disclouser/budget-allotment" element={<Budget/>} />
              <Route path="/rti/proactive-disclouser/manner-of-execution" element={<MannerExecution/>} />
              <Route path="/rti/proactive-disclouser/particulars-of-recipients" element={<ParticularsRecipients/>} />
              <Route path="/rti/proactive-disclouser/details-in-respect-of-information-available" element={<DetailsInformation/>} />
              <Route path="/rti/proactive-disclouser/particulars-of-facilities" element={<Facilities/>} />
              <Route path="/rti/proactive-disclouser/public-information-officers" element={<InformationOfficers/>} />
              <Route path="/rti/proactive-disclouser/faqs" element={<Faqs/>} />
              <Route path="/photo-gallery" element={<Gallery/>} />
              <Route path="/accessibility-statement" element={<Accessibility/>} />
              <Route path="/website-policies" element={<WebsitePolicies/>} />
              <Route path="/terms-and-conditions" element={<Terms/>} />
              <Route path="/disclaimer" element={<Disclaimer/>} />
              <Route path="/help" element={<Help/>} />
              <Route path="/feedback" element={<Feedback/>} />
              <Route path="/sitemap" element={<Sitemap/>} />
              <Route path="/latest-news" element={<News/>} />
            </Routes>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-12">
            <QuickLinks /> 
          </div>
        </div>
      </div>
     
    </>
  );
};

function AppNav() {
  const location = useLocation();
   
  const hideLayout = ["/dashboard", "/dashboard/home","/dashboard/upload-images","/dashboard/upload-notifications","/dashboard/upload-rti-officers","/dashboard/upload-rti-authorities","/dashboard/upload-directory"].includes(location.pathname);
  const hideFooter = ["/dashboard", "/dashboard/home","/dashboard/upload-images","/dashboard/upload-notifications","/dashboard/upload-rti-officers","/dashboard/upload-rti-authorities","/login","/dashboard/upload-directory"].includes(location.pathname);
  return (
  <>
      {!hideLayout && <Header />}
      {!hideLayout &&<Navbar /> }
      {!hideFooter && <AppContent />}
     
      <Routes>
      <Route path='/login' element={<Login />} />
      <Route path="dashboard" element={<Dashboard />}>
            <Route path="home" element={<Home1 />} />
            <Route path="upload-images" element={<Images/>} />
            <Route path="upload-notifications" element={<Notifications1 />} />
            <Route path="upload-rti-officers" element={<Links />} />
            <Route path="upload-directory" element={<Directory />} />
            <Route path="upload-rti-authorities" element={<Authorities />} />
          </Route>
          </Routes>
          {!hideFooter && <Footer />}
          <ToastContainer position="top-center" hideProgressBar="true" autoClose={3000}    />
          </>
  );
}


function App() {
  return (
    <Router>
      <AppNav />
    </Router>
  );
}
export default App;
